import { z } from 'zod';

export const tagSchema = z.object({
  apontamentoId: z.number().optional(),
  titulo: z.string(),
  descricao: z.string().optional(),
  quantidade: z.number(),
});

export const tagImprovementSchema = z.object({
  titulo: z.string(),
  quantidade: z.number(),
});

export const tagsAnalysisResponseSchema = z.object({
  pontosFortes: z.array(tagSchema),
  oportunidadesMelhoria: z.array(tagImprovementSchema),
  interpretacaoPontosFortes: z.string().nullish(),
  interpretacaoOportunidadesMelhoria: z.string().nullish(),
});

export type Tag = z.infer<typeof tagSchema>;
export type TagImprovement = z.infer<typeof tagImprovementSchema>;
export type TagsAnalysisResponse = z.infer<typeof tagsAnalysisResponseSchema>;
